// t530 · B-2268 · EL GABINETE DE ESTE ORDENADOR HOY, COMPARTIDO entre components/PuestoGabinete (que pregunta y lo apunta) y
// utils/MiGabineteEnMenu (la línea «Mi gabinete hoy» del menú de usuario). Sin imports: lo cargan de verdad las guardias que
// pintan el menú (components/Layout).
let _estado = { listo: false }
const _subs = new Set()

export function leerEstadoPuesto() { return _estado }
export function ponerEstadoPuesto(cambio) {
  _estado = { ..._estado, ...(cambio || {}) }
  _subs.forEach((f) => { try { f() } catch (_) { /* nada */ } })
}
export function suscribirPuesto(f) { _subs.add(f); return () => { _subs.delete(f) } }

// El evento de la ventana con el que el menú pide abrir la pregunta.
export function eventoElegirGabinete() { return 'biango-elegir-gabinete' }
